module.exports = __webpack_public_path__ + "static/img/news2.312febf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news1/news2.png
// module id = qmlA
// module chunks = 1